import { styled, isPropValid } from '@migros/msrc-ui-kit';
import React from 'react';
import { roundToOneDecimal } from '../../helpers/round-to-one-decimal';
import { useI18n } from '../../hooks/use-i18n';
import { Rating, RatingSize } from '../rating';
import { migrosAppRatingNumber } from './styles';
export const RatingsSummary = ({
  rating,
  size,
  count,
  showAverageRating
}) => {
  const [i18n] = useI18n();
  return /*#__PURE__*/React.createElement(StyledRatingSummary, {
    size: size
  }, /*#__PURE__*/React.createElement(Rating, {
    size: size,
    ratingRange: 5,
    currentRating: rating
  }), showAverageRating && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RatingNumber, {
    role: "img",
    "aria-label": `${i18n.t('components.rating.average-rating')}: ${roundToOneDecimal(rating)}`
  }, roundToOneDecimal(rating))), typeof count === 'number' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Count, {
    role: "img",
    "aria-label": i18n.t('compositions.reviews-summary.review', {
      count
    }, count)
  }, count)));
};
const StyledRatingSummary = styled.span.withConfig({
  shouldForwardProp: isPropValid
})`
  display: flex;
  align-items: center;
  line-height: 1;
  font-size: ${({
  theme,
  size
}) => {
  const fontSizes = theme.fonts.sizes.text;
  switch (size) {
    case RatingSize.tiny:
      return fontSizes.tiny;
    case RatingSize.small:
      return fontSizes.xsmall;
    case RatingSize.normal:
      return fontSizes.small;
    default:
      return fontSizes.xsmall;
  }
}};
  color: ${({
  theme: {
    colors
  }
}) => colors.tints.gray[60]};
`;
const countStyle = {
  migrosApp: migrosAppRatingNumber
};
const RatingNumber = styled.span`
  margin-left: ${({
  theme: {
    spacings
  }
}) => spacings.small};
  color: ${({
  theme: {
    colors
  }
}) => colors.tints.black[90]};

  ${({
  theme: {
    themeId
  }
}) => countStyle[themeId] || ''}
`;
const Count = styled.span`
  font-family: ${({
  theme: {
    fonts
  }
}) => fonts.families.text};
  line-height: ${({
  theme: {
    lineHeight
  }
}) => lineHeight.normal};
  margin-left: ${({
  theme: {
    spacings
  }
}) => spacings.xsmall};
`;